"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            enrolledCourse: null,
            enrolledProgram: null,
            course: null,
            program: null,
            onStage: null,
            navigation: null,
            showAlert: false,
            showCourseInfo: false,
            showProgramInfo: false,
            showCourseSummary: false,
            showProgramSummary: false,
            loading: true,
            staging: false,
            paymentRequired: false
        };
        this.stats = {};
    },
    onMount: function () {
        this.initialize();
    },
    onCurrentStats: function (stats) {
        this.stats = stats;
    },
    onSpaceAction: function (type, status) {
        switch (type) {
        case 'overview':
            this.state.showCourseInfo = status;
            break;
        case 'program-overview':
            this.state.showProgramInfo = status;
            break;
        }
    },
    getNavigation: function (link, type) {
        if (!link)
            return {};
        let prev, next;
        switch (type) {
        case 'prev':
            prev = getOutline(this.state.course.outlines, link, 'prev');
            break;
        case 'next':
            next = getOutline(this.state.course.outlines, link, 'next');
            break;
        default:
            prev = getOutline(this.state.course.outlines, link, 'prev');
            next = getOutline(this.state.course.outlines, link, 'next');
        }
        return {
            prev,
            next
        };
    },
    onNavigate: function (action, outline) {
        switch (action) {
        case 'next':
            this.declareCourseStage('started', outline);
            break;
        }
    },
    onCompleted: function (records, nextOutline) {
        if (!records)
            return;
        this.declareCourseStage('completed', {
            ...this.state.onStage,
            records
        });
        if (nextOutline)
            this.declareCourseStage('started', nextOutline);
    },
    onDismissSummary: function () {
        this.state.showCourseSummary = false;
        this.state.showProgramSummary = false;
    },
    initialize: async function () {
        this.input.within == 'program' ? await this.mountProgram(this.input.params.id) : await this.mountCourse(this.input.params.id);
    },
    getEnrollment: async function (id) {
        this.state.loading = true;
        const result = await hasEnrolled(id);
        if (!result) {
            navigate(location.pathname.replace('/classroom', ''));
            return;
        }
        if (typeof result === 'string') {
            this.state.loading = result;
            return;
        }
        if (result.payment) {
            const {entity, enrollmentId} = result.payment;
            navigate(`/${ entity.type }/${ entity.id }`);
            return;
        }
        this.state.loading = false;
        return result.enrollment;
    },
    mountProgram: async function (id) {
        const enrollment = await this.getEnrollment(id);
        if (!enrollment)
            return;
        this.state.enrolledProgram = enrollment;
        this.state.program = await getProgram(id);
        if (!this.state.program) {
            this.state.enrolledCourse = false;
            return;
        }
        let stageCourse = this.state.enrolledProgram.progress.stages.slice(-1)[0];
        if (!stageCourse) {
            this.declareProgramStage('started', this.state.program.outlines[0]);
            this.state.showProgramInfo = true;
        } else
            this.mountCourse(stageCourse.reference);
        this.state.enrolledProgram.progress.current.percentage == 100 && this.onProgramCompletion();
    },
    mountCourse: async function (id) {
        const enrollment = await this.getEnrollment(id);
        if (!enrollment)
            return;
        this.state.enrolledCourse = enrollment;
        this.state.course = await getCourse(this.state.enrolledCourse.for.id);
        const stage = this.state.enrolledCourse.progress.stages.slice(-1)[0];
        if (!stage)
            return this.state.showCourseInfo = true;
        this.state.showCourseSummary = false;
        this.state.showCourseInfo = false;
        this.state.navigation = this.getNavigation(stage.link);
        if (this.state.enrolledCourse.progress.current.percentage >= 100)
            return this.onCourseCompletion();
        this.state.onStage = {
            ...getOutline(this.state.course.outlines, stage.link),
            ...stage
        };
        location.hash = stage.link;
    },
    onSubmission: async function (type, submission, callback) {
        if (!type || !['assignment'].includes(type) || isEmpty(submission)) {
            console.debug('[CLASSROOM]: Invalid Submission Parameters');
            return;
        }
        const totalCompleted = this.state.enrolledCourse.progress.completedList.length + 1, stage = {
                completed: true,
                reference: this.state.onStage.reference,
                submission,
                percentage: totalCompleted * 100 / this.stats.lessons + this.stats.tests
            };
        try {
            const {error, message, progess} = await Request(`/classroom/${ this.state.enrolledCourse.enrollmentId }/progress/${ type }`, 'POST', stage);
            if (error)
                throw new Error(message);
            typeof callback == 'function' && callback();
            if (progress.current.percentage >= 100)
                this.onCourseCompletion();
        } catch (error) {
            console.debug('Submission Failed: ', error);
            this.state.alert = 'Check your internet and try again.';
        }
    },
    onProgramCompletion: async function () {
        const assignedCerts = this.state.program.certificates;
        if (assignedCerts && assignedCerts.length) {
            let certificates = this.state.enrolledProgram.rewards.certificates;
            if (!Array.isArray(certificates) || !certificates.length) {
                certificates = [];
                for (let idx = 0; idx < assignedCerts.length; idx++) {
                    const cert = await this.issuedCertificate(assignedCerts[idx], this.state.program, this.state.enrolledProgram.enrollmentId);
                    certificates.push(cert);
                }
            }
            this.state.showProgramSummary = {
                type: 'finished',
                certificates
            };
            return;
        }
        this.state.showProgramSummary = { type: 'finished' };
    },
    onCourseCompletion: async function () {
        let navigation;
        if (!!this.state.program) {
            navigation = {
                prev: false,
                next: false
            };
            for (let o = 0; o < this.state.program.outlines.length; o++)
                if (this.state.program.outlines[o].id == this.state.course.courseId) {
                    navigation.next = this.state.program.outlines[o + 1] || false;
                    break;
                } else
                    navigation.prev = this.state.program.outlines[o];
        }
        const assignedCerts = this.state.course.certificates;
        if (assignedCerts && assignedCerts.length) {
            let certificates = this.state.enrolledCourse.rewards.certificates;
            if (!Array.isArray(certificates) || !certificates.length) {
                certificates = [];
                for (let idx = 0; idx < assignedCerts.length; idx++) {
                    const cert = await this.issuedCertificate(assignedCerts[idx], this.state.course, this.state.enrolledCourse.enrollmentId);
                    certificates.push(cert);
                }
            }
            this.state.showCourseSummary = {
                type: 'finished',
                certificates,
                navigation
            };
            return;
        }
        this.state.showCourseSummary = {
            type: 'finished',
            navigation
        };
    },
    issuedCertificate: async function (cert, target, enrollmentId) {
        try {
            const Learner = GState.get('user'), Form = {
                    to: Learner.email,
                    enrollmentId,
                    version: cert.version,
                    issueData: {
                        recipient_ID: Learner.email,
                        recipient_name: getFullname(Learner),
                        recipient_email: Learner.email,
                        course_name: target.name,
                        program_name: target.name,
                        grade: target.grade || target.points,
                        ...cert.issueData
                    }
                }, {error, message, certificate} = await Request(`/certificate/${ cert.reference }/issue`, 'POST', Form);
            if (error)
                throw new Error(message);
            return certificate;
        } catch (error) {
            console.debug('Failed Issuing Certificate: ', error);
            return {};
        }
    },
    declareProgramStage: async function (status, outline) {
        if (!outline)
            return;
        this.onDismissSummary();
        const {type, id, records} = outline, stage = {
                reference: id,
                type,
                status,
                records
            };
        if (this.state.enrolledProgram.progress.completedList.includes(id)) {
            this.mountCourse(id);
            return;
        }
        if (status == 'completed') {
            const totalCompleted = this.state.enrolledProgram.progress.completedList.length + 1;
            stage.records = {
                ...stage.records || {},
                percentage: totalCompleted * 100 / this.state.program.outlines.length
            };
        }
        this.state.staging = true;
        try {
            const {error, message, progress} = await Request(`/classroom/${ this.state.enrolledProgram.enrollmentId }/progress/stage/declare`, 'POST', stage);
            if (error)
                throw new Error(message);
            this.state.staging = false;
            this.state.enrolledProgram.progress = progress;
            if (stage.status == 'completed' && progress.current.percentage == 100)
                this.onProgramCompletion();
            if (stage.status == 'started')
                this.mountCourse(id);
        } catch (error) {
            console.debug('Failed Declaring a Program\'s Progress Stage: ', error);
            this.state.staging = false;
            this.state.showAlert = 'Check your internet and try again.';
        }
    },
    declareCourseStage: async function (status, outline) {
        if (!outline)
            return;
        this.onDismissSummary();
        const {type, reference, link, records} = outline, stage = {
                type,
                status,
                reference,
                link,
                records
            };
        if (this.state.enrolledCourse.progress.completedList.includes(reference)) {
            location.hash = link;
            this.setState({
                showCourseInfo: false,
                onStage: {
                    ...outline,
                    ...stage
                },
                navigation: this.getNavigation(link)
            });
            return;
        }
        if (status == 'completed') {
            const totalCompleted = this.state.enrolledCourse.progress.completedList.length + 1;
            stage.records = {
                ...stage.records || {},
                percentage: totalCompleted * 100 / this.stats.lessons + this.stats.tests
            };
        }
        this.state.staging = true;
        try {
            const {error, message, progress} = await Request(`/classroom/${ this.state.enrolledCourse.enrollmentId }/progress/stage/declare`, 'POST', stage);
            if (error)
                throw new Error(message);
            this.state.staging = false;
            this.state.enrolledCourse.progress = progress;
            if (stage.status == 'completed') {
                const isCompleted = progress.current.percentage >= 100;
                if (this.state.enrolledProgram !== null)
                    this.updateProgramStage(isCompleted ? 'completed' : 'in-progress', { unitPercentage: progress.current.percentage });
                if (isCompleted) {
                    this.onCourseCompletion();
                    if (this.state.enrolledProgram !== null)
                        this.declareProgramStage('completed', {
                            type: 'course',
                            id: this.state.course.courseId
                        });
                }
            } else {
                location.hash = link;
                this.setState({
                    showCourseInfo: false,
                    onStage: {
                        ...outline,
                        ...stage
                    },
                    navigation: this.getNavigation(link)
                });
            }
        } catch (error) {
            console.debug('Failed Declaring a Progress Stage: ', error);
            this.state.staging = false;
            this.state.showAlert = 'Check your internet and try again.';
        }
    },
    updateProgramStage: async function (status, records) {
        if (!status || isEmpty(records))
            return;
        if (this.state.enrolledProgram.progress.completedList.includes(this.state.course.courseId))
            return;
        const stage = {
            status,
            ...records
        };
        try {
            const {error, message, progress} = await Request(`/classroom/${ this.state.enrolledProgram.enrollmentId }/progress/stage/update`, 'PUT', stage);
            if (error)
                throw new Error(message);
            this.state.enrolledProgram.progress = progress;
        } catch (error) {
            console.debug('Failed Updating a Program\'s Progress Stage: ', error);
            this.state.alert = 'Check your internet and try again.';
        }
    },
    updateCourseStage: async function (status, records) {
        if (!status || isEmpty(records))
            return;
        if (this.state.enrolledCourse.progress.completedList.includes(this.state.onStage.reference))
            return;
        const stage = {
            status,
            ...records
        };
        try {
            const {error, message, progress} = await Request(`/classroom/${ this.state.enrolledCourse.enrollmentId }/progress/stage/update`, 'PUT', stage);
            if (error)
                throw new Error(message);
            debugLog('[CLASSROOM]: Stage Udpate');
        } catch (error) {
            console.debug('Failed Updating a Progress Stage: ', error);
            this.state.alert = 'Check your internet and try again.';
        }
    },
    testStage: async function (status, anwsers) {
        if (!status || isEmpty(anwsers))
            return;
        const stage = {
            completed: status === 'completed',
            reference: this.state.onStage.reference,
            anwsers
        };
        try {
            const {error, message, progress} = await Request(`/classroom/${ this.state.enrolledCourse.enrollmentId }/progress/assessment`, 'POST', stage);
            if (error)
                throw new Error(message);
            if (progress.current.percentage == 100)
                this.onCourseCompletion();
        } catch (error) {
            console.debug('Failed Add Assessment Result: ', error);
            this.state.alert = 'Check your internet and try again.';
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../../../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    Progress_template = require("./components/Progress.marko"),
    Progress_tag = marko_loadTag(Progress_template),
    Extension_template = require("../../../../../../components/Extension/index.marko"),
    Extension_tag = marko_loadTag(Extension_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    ProgramInformation_template = require("./components/ProgramInformation.marko"),
    ProgramInformation_tag = marko_loadTag(ProgramInformation_template),
    CourseInformation_template = require("./components/CourseInformation.marko"),
    CourseInformation_tag = marko_loadTag(CourseInformation_template),
    ProgramSummary_template = require("./components/ProgramSummary.marko"),
    ProgramSummary_tag = marko_loadTag(ProgramSummary_template),
    CourseSummary_template = require("./components/CourseSummary.marko"),
    CourseSummary_tag = marko_loadTag(CourseSummary_template),
    marko_attrs0 = {
        "class": "row no-gutters"
      },
    marko_attrs1 = {
        "class": "col p-0 border-left",
        style: "min-height:100vh"
      },
    marko_attrs2 = {
        "class": "classroom-board"
      };

const Handlers = {
  progress: 'ProgressPro',
  board: 'DLBoard'
};

async function hasEnrolled( id ){
  try {
    const { error, message, reason, ...result } = await Request(`/enrollment/${id}`)
    // Enrolled successfully or there's an issue: Suspension, cancelled, ...
    return result && (result.enrollment || result.payment) ? result : message +(reason ? `: ${reason}` : '')
  }
  catch( error ){
    console.debug(`Error Checking Enrollment: `, error )
    return false
  }
};

async function getCourse( id ){
  try {
    const { error, message, course } = await Request(`/learner/course/${id}`)
    if( error )
      throw new Error( message )

    return course || false
  }
  catch( error ){
    console.debug(`Error Fetching Course: `, error )
    return false
  }
};

async function getProgram( id ){
  try {
    const { error, message, program } = await Request(`/learner/program/${id}`)
    if( error )
      throw new Error( message )

    return program || false
  }
  catch( error ){
    console.debug(`Error Fetching Course: `, error )
    return false
  }
};

function getEntryPointOutline( arg, link = '0', rollback ){
  if( typeof arg != 'object' )
    return false
  
  // Fetch course content outline within a module three
  if( arg.type == 'module' ){
    // target first outline of this module
    if( Array.isArray( arg.outlines ) && arg.outlines.length ){
      /* Target first or last outline in a module
        the rollback (target last outline) is for picking
        the PREV outline in navigation when it's in another
        module than the current.
      */
      const idx = rollback == true ? arg.outlines.length - 1 : 0
      
      link += '.'+ idx
      return getEntryPointOutline( arg.outlines[ idx ], link, rollback )
    }
    // Go to the next module when this module first is empty
    else return false
  }
  
  return { ...arg, link }
};

function getOutline( list, link = '0', sens, originalLink ){
  if( !Array.isArray( list ) ) return
  originalLink = originalLink || link
  
  let outline
  
  switch( sens ){
    case 'next':
    case 'prev': {
      link = link.replace(/([0-9]+)$/, ( matche, x ) => { return Number( x ) +( sens == 'next' ? 1 : -1 ) } )
      outline = getOutline( list, link, false, originalLink )
      
      /* Outline of this next/prev link is not found so 
        consider checking in prev/next module if it exists
      */
      if( !outline ){
        const segs = originalLink.split('.')

        // level up to the parent module of targeted outline
        if( segs.length > 1 ) segs.pop()
        
        // Prev/Next module or outline
        const segsLen = segs.length
        sens == 'next' ?
                +( segs[ segsLen - 1 ] )++ 
                : +( segs[ segsLen - 1 ] )--
                    
        link = segs.join('.')
        // Comes with exact extended link attached
        outline = getEntryPointOutline( list[ segs.pop() ], link, sens == 'prev' )
      }
      // Assign discovery link
      else outline.link = link
      
      return outline
    }

    default: {
      const segs = link.split('.')
      outline = list[ segs.shift() ]
      
      if( !outline ) return

      // find in module or return simple outline
      return segs.length ?
                    getOutline( outline.outlines, segs.join('.'), false, originalLink )
                    : outline
    }
  }
};

function render(input, out, __component, component, state) {
  var data = input;

  if (state.loading === true) {
    LoadingPage_tag({}, out, __component, "0");
  } else if ((typeof state.loading) == "string") {
    EmptyList_tag({
        message: state.enrolledCourse,
        routeTo: "dashboard"
      }, out, __component, "1");
  } else if (state.course === false) {
    EmptyList_tag({
        message: "The page you are trying to access is nowhere to be found",
        routeTo: "dashboard"
      }, out, __component, "2");
  } else {
    if (state.course === null) {
      LoadingPage_tag({}, out, __component, "3");
    } else {
      out.be("div", marko_attrs0, "4", component);

      Progress_tag({
          handler: Handlers.progress,
          payload: {
                  course: {
                    ...(state.course),
                    progress: state.enrolledCourse.progress,
                    stage: state.onStage
                  },
                  program: state.program ? {
                                            poster: state.program.poster,
                                            outlines: state.program.outlines,
                                            progress: state.enrolledProgram.progress,
                                          } : null,
                  active: ( state.showProgramInfo || state.showProgramSummary ) ? 'program' : 'course'
                }
        }, out, __component, "5", [
        [
          "stats",
          "onCurrentStats",
          false
        ],
        [
          "toggle-link",
          "declareCourseStage",
          false
        ],
        [
          "toggle-course",
          "declareProgramStage",
          false
        ]
      ]);

      out.be("div", marko_attrs1, "6", component);

      if (state.onStage) {
        out.be("div", marko_attrs2, "7", component);

        Extension_tag({
            name: Handlers.board,
            payload: {
                stage: state.onStage,
                progress: state.enrolledCourse.progress,
                navigation: state.navigation
              }
          }, out, __component, "8", [
          [
            "classroom-table",
            "testStage",
            false
          ],
          [
            "classroom-completed",
            "onCompleted",
            false
          ],
          [
            "classroom-submitted",
            "onSubmission",
            false
          ],
          [
            "classroom-prev",
            "onNavigate",
            false,
            [
                "prev"
              ]
          ],
          [
            "classroom-progress",
            "updateCourseStage",
            false,
            [
                "in-progress"
              ]
          ],
          [
            "classroom-action",
            "onSpaceAction",
            false
          ]
        ]);

        out.ee();
      }

      if (state.showProgramInfo) {
        ProgramInformation_tag(marko_assign({}, state.program, {
            status: state.enrolledProgram.progress.current.status,
            dates: state.enrolledProgram.dates,
            staging: state.staging
          }), out, __component, "9", [
          [
            "start",
            "onSpaceAction",
            false,
            [
                "program-overview",
                false
              ]
          ],
          [
            "dismiss",
            "onSpaceAction",
            false,
            [
                "program-overview",
                false
              ]
          ]
        ]);
      }

      if (state.showCourseInfo) {
        CourseInformation_tag(marko_assign({}, state.course, {
            status: state.enrolledCourse.progress.current.status,
            dates: state.enrolledCourse.dates,
            staging: state.staging
          }), out, __component, "10", [
          [
            "start",
            "declareCourseStage",
            false,
            [
                "started",
                getEntryPointOutline(state.course.outlines[0])
              ]
          ],
          [
            "dismiss",
            "onSpaceAction",
            false,
            [
                "overview",
                false
              ]
          ]
        ]);
      }

      if (state.showProgramSummary) {
        ProgramSummary_tag(marko_assign({}, state.showProgramSummary, {
            program: state.program,
            status: state.enrolledProgram.progress.current.status,
            dates: state.enrolledProgram.dates
          }), out, __component, "11", [
          [
            "dismiss",
            "onDismissSummary",
            false
          ],
          [
            "navigate",
            "declareProgramStage",
            false
          ]
        ]);
      }

      if (state.showCourseSummary) {
        CourseSummary_tag(marko_assign({}, state.showCourseSummary, {
            course: state.course,
            status: state.enrolledCourse.progress.current.status,
            dates: state.enrolledCourse.dates
          }), out, __component, "12", [
          [
            "dismiss",
            "onDismissSummary",
            false
          ],
          [
            "navigate",
            "declareCourseStage",
            false
          ]
        ]);
      }

      out.ee();

      out.ee();
    }
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
